/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

/**
 * Utility to add common Neo4j-Design styles / behaviour to any HeroIcon.
 *
 * This wrapper is kept in a single place so that the generated icon files
 * can stay **tiny** and tree-shakeable.
 */
import React from 'react';

import type { CommonProps } from '../_common/types';

const ICON_CLASSNAME = 'ndl-icon-svg';

export function wrapIcon<T extends React.ElementType>(Original: T) {
  const Wrapped = ({
    className = '',
    style,
    ref,
    htmlAttributes,
    ...restProps
    // oxlint-disable-next-line @typescript-eslint/no-empty-object-type
  }: CommonProps<T, {}>) => (
    // @ts-expect-error – Original is of any type and we don't know what props it accepts
    <Original
      strokeWidth={1.5}
      style={style}
      className={`${ICON_CLASSNAME} ${className}`.trim()}
      aria-hidden="true"
      {...restProps}
      {...htmlAttributes}
      ref={ref}
    />
  );

  return React.memo(Wrapped);
}
